import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getDomainByHost } from 'utils/domainHelper';
import { pages } from 'containers/Landing/constants';
import ContentfulClient from 'utils/ContentfulClient';
import { fetchPage } from 'utils/contentfulUtils';
import ContentfulFields from 'components/ContentfulFields';

import styles from './styles.scss';
import { selectSelectedServiceLocation } from '../selectors';
import { isSupportedModule } from '../utils';

const MyPromotions = ({ serviceLocation }) => {
  const [title, setTitle] = useState('');
  const [contentModules, setContentModules] = useState([]);

  useEffect(() => {
    async function fetchContent() {
      const contentfulClient = new ContentfulClient();
      const domain = getDomainByHost(22);
      const promotionPage = await fetchPage(
        { ...domain, slug: 'sparkletts' },
        contentfulClient,
        pages.primoMyPromotions,
      );

      const promotionFields = get(promotionPage, 'items[0].fields');
      const count = promotionFields.contentModules.reduce((acc, cur) => {
        if (isSupportedModule(cur, serviceLocation.brandName)) {
          return acc + 1;
        }
        return acc;
      }, 0);
      if (count > 0) {
        setTitle(promotionFields.title);
        setContentModules(promotionFields.contentModules);
      } else {
        const noPromotionPage = await fetchPage(
          { ...domain, slug: 'sparkletts' },
          contentfulClient,
          pages.primoNoPromotions,
        );
        const noPromotionFields = get(noPromotionPage, 'items[0].fields');
        setContentModules(noPromotionFields.contentModules);
      }
    }
    if (serviceLocation) fetchContent();
  }, [serviceLocation]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h1 className={styles.title}>{title}</h1>

        <div className={styles.promos}>
          {contentModules.map((contentModule) => (
            <React.Fragment key={contentModule.sys.id}>
              {serviceLocation &&
                isSupportedModule(contentModule, serviceLocation.brandName) && (
                  <ContentfulFields
                    document={contentModule}
                    type={contentModule.sys.contentType.sys.id}
                  />
                )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  serviceLocation: selectSelectedServiceLocation(),
});

export default connect(mapStateToProps)(MyPromotions);
